import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import * as actions from '../action';
import * as c from '../constant';

function CodedValueContent({
  handleAddModal,
  handleEdit,
  handleRemove,
  codedValueId,
  getSingleCodedValue,
  codedValueInfo,
}) {
  useEffect(() => {
    if (_.isEmpty(codedValueId)) return;
    getSingleCodedValue(codedValueId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(codedValueId)) return;
    getSingleCodedValue(codedValueId);
  }, [codedValueId]);

  return (
    <div className="container-fluid card-section-content">
      <div className="row bg-white pr-2 py-2 mb-2">
        <div className="col-12 d-flex ">
          <button
            type="button"
            onClick={handleAddModal}
            className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-round font-weight-bold px-4 ml-auto"
          >
            Add&nbsp;
            <i className="fas fa-plus" />
          </button>
        </div>
      </div>
      {!_.isEmpty(codedValueInfo) ? (
        <React.Fragment>
          <div className="card">
            <div className="card-body">
              <div className="row d-flex justify-content-between align-items-center">
                <div className="col-10">
                  <h3 className="">Information</h3>
                </div>
                <div className="col-2 d-flex">
                  <div className="ml-auto">
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleEdit(codedValueInfo)}
                    >
                      <i className="far fa-edit icon-edit" />
                    </button>
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleRemove(codedValueInfo)}
                    >
                      <i className="far fa-trash-alt icon-delete" />
                    </button>
                  </div>
                </div>
              </div>
              <hr />
              <div className="mt-1">
                <div className="row d-flex justify-content-center">
                  <div className="col-12">
                    <div className="form-wrapper mb-3">
                      <div className="full-group border-bottom">
                        <div className="form-row">
                          <div className="form-input-group col-12 border-right">
                            <label className="full-label mb-0">Name:</label>
                            <span className="full-input">
                              {_.get(codedValueInfo, 'attributes.name') ||
                                '--'}
                            </span>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="form-input-group col-12 border-right">
                            <label className="full-label mb-0">Code:</label>
                            <span className="full-input">
                              {_.get(codedValueInfo, 'attributes.code') ||
                                '--'}
                            </span>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="form-input-group col-12 border-right">
                            <label className="full-label mb-0">Description:</label>
                            <span className="full-input">
                              {_.get(codedValueInfo, 'attributes.description') ||
                                '--'}
                            </span>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="form-input-group col-12 border-right">
                            <label className="full-label mb-0">Is Active:</label>
                            <span className="full-input">
                              {_.get(
                                codedValueInfo,
                                'attributes.is_active'
                              )
                                ? 'YES'
                                : 'NO'}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      ) : (
        <div className="d-flex align-items-center justitfy-content-center h-100">
          <div className="text-center mx-auto py-4">
            <img
              src={emptyStateImage}
              className="img-responsive image-wrapper mb-4 mt-3"
              alt="Empty State"
            />
            <p className="emp-title mb-0"> No Item Found </p>
          </div>
        </div>
      )}
    </div>
  );
}

CodedValueContent.propTypes = {
  handleAddModal: PropTypes.instanceOf(Function).isRequired,
  handleEdit: PropTypes.instanceOf(Function).isRequired,
  handleRemove: PropTypes.instanceOf(Function).isRequired,

  getSingleCodedValue: PropTypes.instanceOf(Function).isRequired,
  codedValueInfo: PropTypes.instanceOf(Object).isRequired,
  codedValueId: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  codedValueInfo: _.get(api, `${c.GET_SINGLE_CODED_VALUE}.item`) || {},
  codedValueId: _.get(match, 'params.codedValueId') || '',
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(CodedValueContent);
